import { PointsType } from '@/types';
import { WalletType } from '@web3/base-utils';

export const taskSupportWallet = [
  WalletType.MNEMONIC_PHRASE,
  WalletType.PRIVATE_KEY,
];

export const wsotSupportWallet = [WalletType.CLOUD, ...taskSupportWallet];

export const redemptionSupportWallet = [
  WalletType.CLOUD,
  WalletType.MNEMONIC_PHRASE,
];

export const pointsTypes = [
  PointsType.trade,
  PointsType.dex100,
  PointsType.createWallet,
  PointsType.wsot,
  PointsType.socialmedia,
].join(',');
